<svg id="chart" width="17" height="17">
    <circle class="full" r="8.5" cx="8.5" cy="8.5" [ngStyle]="{'stroke-dasharray': (percent / 100) * 53.4 + ' 53.4'}" />
</svg>
<svg id="background" width="17" height="17">
    <path id="Available_space_icon" data-name="Available space icon" d="M8.5,17A8.5,8.5,0,1,1,17,8.5,8.51,8.51,0,0,1,8.5,17Zm0-12A3.48,3.48,0,1,0,12,8.5,3.48,3.48,0,0,0,8.5,5Z" fill="#e5e5e7"/>
</svg>
